/* eslint-disable no-loop-func */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import {
  CSSProperties,
  Dispatch,
  ReactNode,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import { Table as BootstrapTable } from "react-bootstrap";
import { useSortableData } from "../hooks/useSortedTable";
import { TablePagination } from "./Table Component/TablePagination";
import { TableSearch } from "./Table Component/TableSearch";
import { useUID } from "react-uid";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { NoData } from "./NoData";
import "../font/AmiriFont";
import styled from "styled-components";
import { Sort } from "@styled-icons/boxicons-regular/Sort";
import DescriptionTooltip from "./common/DescriptionTooltip/descriptionTooltip";
import "./Table Component/TableStyle.css";
import Tooltip from "@mui/material/Tooltip";
export const width62pxStyle = { width: "62px" };
export const width35pxStyle = { width: "35px" };
export const width80pxStyle = { width: "80px" };
export const width100pxStyle = { width: "100px" };
export const width150pxStyle = { width: "150px" };
export const width250pxStyle = { width: "250px" };

export type TableProps = {
  pageTitle: string;
  columns: Array<{
    name: string;
    style?: CSSProperties;
    attr: string;
    tooltib?: string;
  }>;
  rowsData: Array<any>;
  rows?: (currentPageRowsData: Array<any>) => Array<ReactNode>;
  getCells?: (row: any) => Array<ReactNode>;
  rowsStrings?: {
    key: string | Array<string>;
    items: Array<Array<string>> | undefined;
  };
  excelData: any;
  currentApps?: any;
  intialPage?: number | undefined | null;
  setintialPage?: Dispatch<SetStateAction<null>>;
  tabId?: string;
};

const SortDescIcon = styled(Sort)`
  width: 30px;
  height: 21px;
  color: #b9b9b9;
`;
export function Table(props: TableProps) {
  const {
    columns,
    rowsStrings,
    rowsData,
    pageTitle,
    excelData,
    currentApps,
    intialPage,
    tabId,
  } = props;
  const [tableRowsPerPage, setTableRowsPerPage] = useState(10);
  // Making them in one object to change both of them atomically
  const [currentPageAndSearchTerm, setCurrentPageAndSearchTerm] = useState({
    currentPage: intialPage,
    searchTerm: "",
  });
  const uid = useUID();
  const headers: Array<string> = [];
  const arrOfData: Array<Array<any>> = [];
  const body: Array<Array<string>> = [];
  type RowData = {
    applicationName: string;
    applicationVersion: string;
  };
  const items: RowData[] = rowsData.map((item: any) => {
    return {
      applicationName: item?.applicationName,
      applicationVersion: item?.applicationVersion,
    };
  });
  items.forEach((item: RowData) => {
    body.push([item.applicationName, item.applicationVersion]);
  });
  const toPdf = () => {
    const pdf: any = new jsPDF("p");
    pdf.setFont("Amiri-Regular");
    pdf.autoTable({
      html: `#pdf-${uid}`,
      headStyles: { font: "Amiri-Regular" },
      bodyStyles: { font: "Amiri-Regular" },
    });
    pdf.save(`${pageTitle}-report.pdf`);
  };
  columns.forEach((el) => {
    if (el.attr !== "" && el.attr !== "isAllowed") {
      headers.push(el.name);
    }
    return 0;
  });
  excelData.map((el: any) => {
    let singleRow: Array<any> = Object.values(el);
    arrOfData.push(singleRow);
    return 0;
  });

  useEffect(() => {
    setCurrentPageAndSearchTerm({
      currentPage: 1,
      searchTerm: "",
    });
  }, [tabId, intialPage, currentApps, pageTitle]);

  const excelContent: any = [headers, ...arrOfData];
  const currentPage: any = currentPageAndSearchTerm.currentPage;
  const searchTerm = currentPageAndSearchTerm.searchTerm;
  const setCurrentPage = (newCurrentPage: number) =>
    setCurrentPageAndSearchTerm({
      currentPage: newCurrentPage,
      searchTerm,
    });
  const setSearchTerm = (newSearchTerm: string) =>
    setCurrentPageAndSearchTerm({ currentPage: 1, searchTerm: newSearchTerm });

  const { key }: any = rowsStrings;
  const searchedData = rowsData.filter((row) => {
    if (searchTerm === "") {
      return true;
    } else {
      if (Array.isArray(key)) {
        return key.some((k: string) =>
          row[k]
            ?.toString()
            .toLowerCase()
            .includes(searchTerm.toLowerCase().trim())
        );
      } else if (typeof key === "string") {
        return row[key]
          ?.toString()
          .toLowerCase()
          .includes(searchTerm.toLowerCase().trim());
      } else {
        return false; // Invalid key format
      }
    }
  });
  const { items: sortedSearchedRowsData, requestSort } =
    useSortableData(searchedData);

  const indexOfLastPost = currentPage * tableRowsPerPage;
  const indexOfFirstPost = indexOfLastPost - tableRowsPerPage;
  const currentPageRowsData = sortedSearchedRowsData.slice(
    indexOfFirstPost,
    indexOfLastPost
  );

  const haveNoSortingHeaders = [
    "Details",
    "Trend",
    "Disallow",
    "Allowed",
    "Delete",
    "Edit",
    "Reset Password",
    "Application Version",
    "Version",
    "Devices",
  ];
  const tableHeadings = columns.map((column, index) => (
    <th
      key={index}
      className={`th-sm ${column.attr}`}
      style={column.style}
      onClick={() => column.attr !== "" && requestSort(column.attr)}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        {column.tooltib !== undefined ? (
          <Tooltip title={column.tooltib} placement="top" arrow>
            <div>{column.name}</div>
          </Tooltip>
        ) : (
          column.name
        )}
        {column.name === "Avg Response Time (sec)" && (
          <DescriptionTooltip
            description={
              "Response time refers to the amount of time application server takes to return the results of a request to the user."
            }
          />
        )}
        {!haveNoSortingHeaders.includes(column.name) && <SortDescIcon />}
      </div>
    </th>
  ));

  const pdfTableHeadings = columns
    .filter((el) => {
      return el.attr !== "" && el.attr !== "isAllowed";
    })
    .map((column, index) => (
      <th
        key={index}
        style={column.style}
        onClick={column.attr === "" ? () => {} : () => requestSort(column.attr)}
      >
        {column.name}
      </th>
    ));

  return (
    <>
      <div className="table-container">
        <TableSearch
          toPdf={toPdf}
          pageTitle={pageTitle}
          excelContent={excelContent}
          arrayLength={sortedSearchedRowsData.length}
          setTableRowsPerPage={setTableRowsPerPage}
          tableRowsPerPage={tableRowsPerPage}
          setSearchTerm={setSearchTerm}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
        />
        {currentPageRowsData.length === 0 || rowsData.length === 0 ? (
          <NoData />
        ) : (
          <>
            <div className="my-tabel-styling">
              <BootstrapTable>
                <thead>
                  <tr>{tableHeadings}</tr>
                </thead>

                <tbody>
                  {props.getCells !== undefined &&
                    currentPageRowsData.map((row, index) => (
                      <tr key={index}>
                        {props.getCells &&
                          props
                            .getCells(row)
                            .map((cell, index) => <td key={index}>{cell}</td>)}
                      </tr>
                    ))}
                  {props.rows !== undefined && props.rows(currentPageRowsData)}
                </tbody>
              </BootstrapTable>
              <BootstrapTable
                responsive
                striped
                id={`pdf-${uid}`}
                style={{ display: "none" }}
                className={`${
                  rowsData.length === 0 || currentPageRowsData.length === 0
                    ? "overflow-hidden"
                    : "overflow-auto"
                }`}
              >
                <thead>
                  <tr>{pdfTableHeadings}</tr>
                </thead>
                <tbody>
                  {props.rows !== undefined &&
                    props.rows(sortedSearchedRowsData)}
                </tbody>
              </BootstrapTable>
            </div>
          </>
        )}
      </div>
      {currentPageRowsData.length === 0 || rowsData.length === 0 ? (
        ""
      ) : (
        <TablePagination
          totalRowsCount={sortedSearchedRowsData.length}
          currentPage={currentPage}
          tableRowsPerPage={tableRowsPerPage}
          setCurrentPage={setCurrentPage}
        />
      )}
    </>
  );
}
